import pdfMake from "pdfmake/build/pdfmake.min";
import { pdfMake as pdfFonts } from "pdfmake/build/vfs_fonts";

pdfMake.vfs = pdfFonts.vfs;

function studentName(student) {
  return (
    student.fullName ||
    [student.firstName, student.lastName].filter(Boolean).join(" ") ||
    "Unnamed student"
  );
}

function parentName(student) {
  const customer = student.Customer || {};
  return customer.name || customer.fatherName || "—";
}

export function createStudentListReportPdfBlob({ business, classroom, enrollments }) {
  const students = enrollments
    .map((enrollment) => enrollment && enrollment.Student)
    .filter(Boolean)
    .sort((left, right) => studentName(left).localeCompare(studentName(right)));
  const teachers = (classroom.ClassRoomTeachers || [])
    .map((assignment) => assignment.Teacher && assignment.Teacher.name)
    .filter(Boolean)
    .join(", ") || "Not assigned";
  const department = classroom.Class && classroom.Class.name
    ? classroom.Class.name
    : "Not assigned";
  const generatedAt = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date());

  const body = [
    [
      { text: "#", style: "tableHeader", alignment: "center" },
      { text: "Student", style: "tableHeader" },
      { text: "Reference", style: "tableHeader" },
      { text: "Parent / Guardian", style: "tableHeader" },
    ],
    ...students.map((student, index) => [
      { text: String(index + 1), alignment: "center" },
      studentName(student),
      student.reference || "—",
      parentName(student),
    ]),
  ];

  const definition = {
    pageSize: "LETTER",
    pageMargins: [42, 42, 42, 50],
    defaultStyle: { font: "Roboto", fontSize: 10, color: "#26332b" },
    footer(currentPage, pageCount) {
      return {
        text: `Page ${currentPage} of ${pageCount}`,
        alignment: "center",
        color: "#7a867e",
        fontSize: 8,
      };
    },
    content: [
      {
        text: business && business.name ? business.name : "Taleem",
        bold: true,
        fontSize: 11,
        color: "#3f9f48",
        alignment: "center",
      },
      {
        text: "STUDENT LIST",
        bold: true,
        fontSize: 20,
        alignment: "center",
        margin: [0, 4, 0, 20],
      },
      {
        columns: [
          [
            { text: [{ text: "Classroom: ", bold: true }, classroom.name || "Unnamed classroom"] },
            { text: [{ text: "Department: ", bold: true }, department], margin: [0, 4, 0, 0] },
          ],
          [
            { text: [{ text: "Teacher(s): ", bold: true }, teachers], alignment: "right" },
            { text: [{ text: "Generated: ", bold: true }, generatedAt], alignment: "right", margin: [0, 4, 0, 0] },
          ],
        ],
        margin: [0, 0, 0, 14],
      },
      { text: `${students.length} ${students.length === 1 ? "student" : "students"}`, bold: true, margin: [0, 0, 0, 6] },
      {
        table: {
          headerRows: 1,
          widths: [24, "*", 90, 150],
          body,
        },
        layout: {
          fillColor(rowIndex) {
            if (rowIndex === 0) return "#3f9f48";
            return rowIndex % 2 === 0 ? "#f3f7f3" : null;
          },
          hLineColor: "#dce5de",
          vLineColor: "#dce5de",
          paddingLeft: () => 7,
          paddingRight: () => 7,
          paddingTop: () => 6,
          paddingBottom: () => 6,
        },
      },
    ],
    styles: {
      tableHeader: { bold: true, color: "#ffffff", fontSize: 9 },
    },
  };

  return new Promise((resolve, reject) => {
    try {
      pdfMake.createPdf(definition).getBlob(resolve);
    } catch (error) {
      reject(error);
    }
  });
}
